import { animate, AnimationTriggerMetadata, style, transition, trigger } from "@angular/animations";

const ANIMATION_DURATION = '300ms';
const TRANSITION = ANIMATION_DURATION + ' ease-in-out';

export const menuAnimation: AnimationTriggerMetadata = trigger(
    'iccDropdownAnimation',
    [
        transition(`* => fadeInTop`, [
            style({transform: 'translateY(-10px)', opacity: 0}),
            animate(TRANSITION, style({transform: 'translateY(0)', opacity: 1})),
        ]),
        transition(`* => fadeInBottom`, [
            style({transform: 'translateY(10px)', opacity: 0}),
            animate(TRANSITION, style({transform: 'translateY(0)', opacity: 1})),
        ]),
        transition(`fadeInBottom => *`, [
            style({transform: 'translateY(0)', opacity: 1}),
            animate(TRANSITION, style({transform: 'translateY(10px)', opacity: 0})),
        ]),
        transition(`fadeInTop => *`, [
            style({transform: 'translateY(0)', opacity: 1}),
            animate(TRANSITION, style({transform: 'translateY(-10px)', opacity: 0})),
        ]),
    ],
);
